<script lang="ts" setup>
  import type { TextareaProps } from '#ui/components/Textarea.vue';
  import { useAttrs } from 'vue';

  const props = withDefaults(
    defineProps<{
      name?: string;
      placeholder?: string;
      color?: TComponentColor;
      size?: TComponentSize;
      required?: boolean;
      autofocus?: boolean;
      autofocusDelay?: number;
      autoresize?: boolean;
      autoresizeDelay?: number;
      disabled?: boolean;
      class?: any;
      rows?: number;
      maxrows?: number;
      highlight?: boolean;
    }>(),
    {
      maxrows: 3,
      size: 'xl',
      autoresize: true,
      rows: 5,
    },
  );

  const DEFAULT_UI_SETTINGS: TextareaProps = {
    ui: {
      base: 'focus:ring-0 ring-0 bg-black/30 border border-white/20 resize-none text-white',
    },
  };

  const modelValue = defineModel<string | number | null | undefined>();
  const attrs = useAttrs();

  const uiPayload = computed(() => ({ ...attrs, ...props, ...DEFAULT_UI_SETTINGS }));
</script>

<template>
  <UTextarea v-model="modelValue" :class="[attrs.class, props.class]" class="core-textarea w-full" v-bind="uiPayload" />
</template>
